import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { AbstractToggleFormComponent, EditablePanelComponent } from '@spike/scaffolds';
import { FormFactoryService } from '../../../shared/services/form-factory.service';
import { AsyncApiService } from '@spike/core';
import { PositionShippingFormComponent } from "../../forms/position-shipping-form/position-shipping-form";
import { WorkPhase } from 'src/app/features/workflow/models/workphase.model';
import { Shipping } from '../../models/shipping.model';
import { ShippingWorkflow } from 'src/app/features/workflow/models/workflow-status.enum';
import { EntityApiEnum } from 'src/app/config/entity-api.enum';


@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'spike-shipping-toggle-panel',
  providers:[],
  imports: [EditablePanelComponent, PositionShippingFormComponent],
  templateUrl: './shipping-toggle-panel.html'
})
export class ShippingTogglePanel extends AbstractToggleFormComponent<WorkPhase>{

  // Inject
  private readonly asyncApi = inject(AsyncApiService);
  private readonly formFactory = inject(FormFactoryService);

  // Input
  public readonly data = input.required<Shipping>();
  
  // Output
  public readonly onSave = output<Shipping|undefined>();


  // State
  public readonly workflowState=ShippingWorkflow;

  //forms
  public readonly form = this.formFactory.createShippingForm();

  override disabledFields= computed(()=>{
    const data = this.data();
    if(!data || !this.workflowState) return [];
    return this.workflowState?.list?.find(x=>x.id == data?.stateId)?.disabledFields??[];
  })

  public readonly isReadOnly= computed(()=>{
    const data = this.data();
    const workflowState = this.workflowState;
    if(!data || !workflowState) return false;
    return !!workflowState?.list?.find(x=>x.id == data?.stateId)?.readonly;
  })



  async save() {
    this.form.markAllAsTouched();
    if (this.form.valid) {
      const generalValues = this.form.getRawValue();
      const toSaveData: any = {
        ...generalValues,
      };

      await this.asyncApi.save<Shipping>(EntityApiEnum.SHIPPING, toSaveData, this.data()!.shippingId);
      this.onUpdate();
    }
  }

  public onUpdate(){
    this.onSave.emit(this.data())
  }

  protected override buildFormArrays(): void {}

}